// mitt event used by Message.vue (context menu) to open the global forward dialog
export const WASAPI_FORWARD_MESSAGE = 'wasapi:forward-message';
